import useToast from './ui/useToasts';

export default useToast;
